// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/medical-certification-process.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/medical-certification-process/medical-certification-process.js';

mount([g0]);
